import { updateObjectInChildArrayAndRefreshCount } from "../utils/dbUtils";
import { auth } from "../firebase";
import { isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';
import { toSubmittedAtDate } from '../utils/dateFormatter';
import { v4 as uuid } from 'uuid';
import Order from "./Order";

class OrderForm {
    id = uuid();
    userId = null;

    surveyId = null;
    answers = [];

    submittedAt = null; // only set the value if the form is completed moment().utc().toDate()

    createdBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    createdAt = moment().utc().toDate();
    modifiedBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    modifiedAt = moment().utc().toDate();

    constructor(orderForm) {
        if (isObjectNotEmpty(orderForm)) {
            if (isStringNotEmpty(orderForm.id)) { this.id = orderForm.id; }
            if (isStringNotEmpty(orderForm.userId)) { this.userId = orderForm.userId; }

            if (isStringNotEmpty(orderForm.surveyId)) { this.surveyId = orderForm.surveyId; }
            if (isListNotEmpty(orderForm.answers)) { this.answers = orderForm.answers; }

            // the checkout callable rasterises a client Timestamp into a { seconds, nanoseconds } map,
            // which nothing can order - coerce it back on receipt
            if (isNotNullOrUndefined(orderForm.submittedAt)) { this.submittedAt = toSubmittedAtDate(orderForm.submittedAt); }

            if (isStringNotEmpty(orderForm.createdBy)) { this.createdBy = orderForm.createdBy; }
            if (isNotNullOrUndefined(orderForm.createdAt)) { this.createdAt = orderForm.createdAt; }
            if (isStringNotEmpty(orderForm.modifiedBy)) { this.modifiedBy = orderForm.modifiedBy; }
            if (isNotNullOrUndefined(orderForm.modifiedAt)) { this.modifiedAt = orderForm.modifiedAt; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            userId: this.userId,

            surveyId: this.surveyId,
            answers: this.answers,

            submittedAt: this.submittedAt,

            createdAt: this.createdAt,
            createdBy: this.createdBy,
            modifiedAt: this.modifiedAt,
            modifiedBy: this.modifiedBy
        };
    }

    static create = async (orderId, formId, newForm) => {
        const newObj = new OrderForm({
            id: formId,
            ...newForm,
            createdAt: moment().utc().toDate(),
            createdBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM',
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        const success = await updateObjectInChildArrayAndRefreshCount(Order.collectionName, orderId, 'forms', 'id', newObj.toDto(), 'formsCount');
        if (isBooleanTrue(success)) {
            return newObj.toDto();
        }

        return null;
    }

    static update = async (orderId, formId, updatedForm) => {
        const updatedObj = new OrderForm({
            id: formId,
            ...updatedForm,
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        if (formId === updatedForm.id) {
            const success = await updateObjectInChildArrayAndRefreshCount(Order.collectionName, orderId, 'forms', 'id', updatedObj.toDto(), 'formsCount');
            if (isBooleanTrue(success)) {
                return updatedObj.toDto();
            }
        } else {
            throw new Error('id and id field of the updated form must match.')
        }

        return null;
    }
};

export default OrderForm;